"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleVisibilityChange = exports.isDocumentHidden = void 0;
var hidden, visibilityChange;
try {
    if (typeof document.hidden !== 'undefined') {
        // Opera 12.10 and Firefox 18 and later support
        hidden = 'hidden';
        visibilityChange = 'visibilitychange';
    }
    else if (typeof document.msHidden !== 'undefined') {
        hidden = 'msHidden';
        visibilityChange = 'msvisibilitychange';
    }
    else if (typeof document.webkitHidden !== 'undefined') {
        hidden = 'webkitHidden';
        visibilityChange = 'webkitvisibilitychange';
    }
}
catch (_a) { }
function isDocumentHidden() {
    return document[hidden];
}
exports.isDocumentHidden = isDocumentHidden;
function handleVisibilityChange(callback) {
    var wrappedCallback = function () { return callback(isDocumentHidden()); };
    var cancelListener = function () { return window.removeEventListener(visibilityChange, wrappedCallback, true); };
    window.addEventListener(visibilityChange, wrappedCallback, true);
    return cancelListener;
}
exports.handleVisibilityChange = handleVisibilityChange;
//# sourceMappingURL=index.js.map